import BannerPage from "./BannerPage";

export default BannerPage;
